
<div
  v-if="!table"
  class="tree-node"
  :class="{ 'tree-node--with-tree-line': treeLine }"
  :style="indentStyle"
  ref="el"
  v-bind="ariaAttrs"
>
  <template v-if="treeLine">
    <div
      v-for="line in vLines"
      class="tree-line tree-vline"
      :style="line.style"
    ></div>
    <div
      v-if="stat.level > 1"
      class="tree-line tree-hline"
      :style="hLineStyle"
    ></div>
  </template>
  <div class="tree-node-inner">
    <slot :indentStyle="indentStyle"></slot>
  </div>
</div>
<tr v-else class="tree-node" ref="el" v-bind="ariaAttrs">
  <slot :indentStyle="indentStyle"></slot>
</tr>
